enum ModalToOpen {
	MergeConfirm = "MergeConfirm",
	MergeResolver = "MergeResolver",

	Publish = "Publish",

	ShareTicketHandler = "ShareTicketHandler",
	ReviewTicketHandler = "ReviewTicketHandler",

	CheckoutHandler = "CheckoutHander",
	CloneHandler = "CloneHandler",
	PullHandler = "PullHandler",

	SnippetEditor = "SnippetEditor",
	SnippetAlreadyUseWarn = "SnippetAlreadyUseWarn",

	Loading = "Loading",

	MultilangActionConfirm = "MultilangActionConfirm",

	DiagramEditor = "DiagramEditor",
	HTMLEditor = "HTMLEditor",

	Merge = "Merge",
	CreateMergeRequest = "CreateMergeRequest",
	MergeRequestConfirm = "MergeRequestConfirm",
	CreateSourceData = "CreateSourceData",

	EditEnterpriseConfig = "EditEnterpriseConfig",
}

export default ModalToOpen;
